import { render, staticRenderFns } from "./Staging-Design-Detail.vue?vue&type=template&id=f33fed92&scoped=true&"
import script from "./Staging-Design-Detail.vue?vue&type=script&lang=js&"
export * from "./Staging-Design-Detail.vue?vue&type=script&lang=js&"
import style0 from "./Staging-Design-Detail.vue?vue&type=style&index=0&id=f33fed92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33fed92",
  null
  
)

export default component.exports